export const navigation = [
  // {
  //   title: true,
  //   name: 'Dashboard',
  //   wrapper: {            // optional wrapper object
  //     element: 'span',      // required valid HTML5 element tag
  //     attributes: {}        // optional valid JS object with JS API naming ex: { className: 'my-class', style: { fontFamily: 'Verdana' }, id: 'my-id'}
  //   },
  //   class: 'text-center'             // optional class names space delimited list for title item ex: 'text-center'
  // },
 
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'info',
      text: 'NEW'
    }
  },
  {
    name: 'Persons',
    url: '/persons',
    icon: 'icon-people'
  },
  {
    name: 'Companies',
    url: '/companies',
    icon: 'fa fa-building-o'
  },
  // {
  //   title: true,
  //   name: 'UI elements',
  //   wrapper: {
  //     element: 'span',
  //     attributes: {}
  //   },
  //   class: 'text-center'
  // },
  {
    name: 'Publications',
    url: '/publications',
    icon: 'icon-book-open',
    children: [
      {
        name: 'Pivotal',
        url: '#',
        icon: 'icon-book-open',
        children: [
          {
            name: 'CLL Print',
            url: '/publications/CLLP',
            icon: 'icon-notebook'
          },
          {
            name: 'CLL Web',
            url: '/publications/CLLW',
            icon: 'icon-notebook'
          },
          {
            name: 'AB Phone Book',
            url: '/publications/ABPhone',
            icon: 'icon-notebook'
          },
          {
            name: 'ON Phone Book',
            url: '/publications/ONPhone',
            icon: 'icon-notebook'
          },
          {
            name: 'BC Phone Book',
            url: '/publications/BCPhone',
            icon: 'icon-notebook'
          },
          {
            name: 'ATLANTIC Phone Book',
            url: '/publications/ATPhone',
            icon: 'icon-notebook'
          },
          {
            name: 'Findlaw.ca',
            url: '/publications/Findlaw',
            icon: 'icon-globe'
          }
        ]
      },
      {
        name: 'ALM 500 Directory',
        url: '/publications/ALM',
        icon: 'icon-book-open'
      },
      {
        name: 'Canadian Directory',
        url: '/publications/DIR',
        icon: 'icon-book-open'
      },
      {
        name: 'CCCA Directory',
        url: '/publications/CCCA',
        icon: 'icon-book-open'
      },
      {
        name: 'Inserts & Guides',
        url: '#',
        icon: 'icon-book-open',
        children: [
          {
            name: 'US Guide',
            url: '/publications/USG',
            icon: 'icon-notebook'
          },
          {
            name: 'ROB Insert',
            url: '/publications/ROB',
            icon: 'icon-notebook'
          },
          {
            name: 'Lexpert® SE – Global Mining',
            url: '/publications/MIN',
            icon: 'icon-notebook'
          },
          {
            name: 'Lexpert® USG-CORP',
            url: '/publications/USG-CORP',
            icon: 'icon-notebook'
          },
          {
            name: 'Lexpert® SE – Energy',
            url: '/publications/SE-ENERGY',
            icon: 'icon-notebook'
          },
          {
            name: 'Lexpert® USG-LIT',
            url: '/publications/USG-LIT',
            icon: 'icon-notebook'
          },
          {
            name: 'Lexpert® SE – Litigation',
            url: '/publications/SE-LIT',
            icon: 'icon-notebook'
          },
          {
            name: 'Lexpert® SE – Corporate',
            url: '/publications/SE-CORP',
            icon: 'icon-notebook'
          },
          {
            name: 'Lexpert® SE – Infrastructure',
            url: '/publications/SE-INFRA',
            icon: 'icon-notebook'
          },
          {
            name: 'Lexpert® SE – Global Mining',
            url: '/publications/SE-MIN',
            icon: 'icon-notebook'
          }
        ]
      }
      

    ]
  },
  {
    name: 'Survey',
    url: '/survey',
    icon: 'icon-like',
    children: [
      {
        name: 'Survey',
        url: '/survey',
        icon: 'icon-like'
      }
    ]
  },
  {
    name: 'Administration',
    url: '/admin',
    icon: 'icon-settings'    
  },
  {
    name: 'Reports',
    url: '#',
    icon: 'icon-chart',
    children: [
      {
        name: 'Queries',
        url: '/queries/0',
        icon: 'icon-chart'
      },
      {
        name: 'Reports',
        url: '/queries/1',
        icon: 'icon-chart'
      }
    ]
  }
  
];
